export default "__VITE_ASSET__Dh_J82h1__"